import { FC } from "react";
import * as _ from "lodash";

import { Col, Alert } from "@ctra/components";

import { SectionList } from "@ctra/api";
import { makeList } from "@ctra/utils";
import { Enterprise, useTranslation } from "@ctra/i18n";

interface UnsupportedAlertProps {
  unsupportedSections: SectionList;
}

/**
 * Alert to show the unsupported dashboards if any
 */
export const UnsupportedAlert: FC<UnsupportedAlertProps> = ({ unsupportedSections }) => {
  const { t } = useTranslation();

  const {
    layouts: {
      section: {
        title: sectionTitle,
        unsupported: { title, description }
      }
    },
    grammar: {
      conjunction: { and }
    }
  } = Enterprise;

  /**
   * Create array of section titles
   */
  const unsupportedSectionTitles = _.map(unsupportedSections, ({ title }) =>
    t<string>(sectionTitle(title), { makeDefaultValue: true })
  );
  /**
   * Comma and conjunction seperated list of all the unsupported sections
   */
  const sections = makeList(unsupportedSectionTitles, t<string>(and));

  const renderTag = (asset: string) => sections && t<string>(asset, { sections });

  return (
    <Col span={24}>
      <Alert message={renderTag(title)} description={renderTag(description)} type="info" closable showIcon />
    </Col>
  );
};
